import styled from "styled-components";

export const WRAPPER = styled.section`
	width: 100%;
	margin-bottom: 24px;
	padding: 0;
	box-sizing: border-box;

	@media (max-width: 767px) {
		margin-bottom: 14px;
	}
`;

export const BANNER = styled.div`
	width: 100%;
	border-radius: 16px;
	overflow: hidden;

	.swiper-slide {
		border-radius: 16px;
		overflow: hidden;
	}

	img,
	video {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 16px;
	}

	@media (max-width: 767px) {
		border-radius: 12px;

		.swiper-slide,
		img,
		video {
			border-radius: 12px;
		}
	}
`;

export const PAGINATION = styled.div`
	display: flex;
	justify-content: center;
	gap: 6px;
	margin-top: 10px;

	.swiper-pagination-bullet {
		width: 8px;
		height: 8px;
		border-radius: 999px;
		background: rgba(229, 240, 254, 0.3);
		opacity: 1;
		transition:
			width 0.2s ease,
			background 0.2s ease;
	}

	.swiper-pagination-bullet-active {
		width: 22px;
		background: var(--main-color, #5297ff);
	}
`;
